import dayjs from 'dayjs';

export const formatDate = (date: Date | string): string =>
  dayjs(date).format('YYYY-MM-DD');

export const formatDateWithTime = (date: Date | string): string =>
  dayjs(date).format('YYYY-MM-DD HH:mm');

export const formatDateWithTimeAMPM = (date: Date | string): string => {

  if (date == null || date == 'N/A') return 'N/A'

  return dayjs(date).format('YYYY-MM-DD HH:mm A'); //TODO: casos especificos
}

export const formatHour = (time?: string): string => {
  return dayjs(time, 'HH:mm:ss').format('hh:mm A');
};

export const formatHourHH = (time?: string): string => {
  return dayjs(time, 'HH:mm:ss').format('hh:mm:ss');
};

export const formatDateToISOString = (date: Date | string): string =>
  dayjs(date).toISOString();

/**
 * 
 * Convertir una fecha en una hora
 * 
 */

export const formatGetHour = (date?: string | null): string | null => {
  if (date || date != null)
    return dayjs(date).format('HH:mm:ss');
  return null;
};

/**
 * 
 * Convertir una hora en fecha
 * 
*/
export const convertHourDate = (time?: string): string | null => {
  if (time) {
    const formattedDate = dayjs(`${formatDate(new Date)}T${time}`).format('YYYY-MM-DDTHH:mm');
    return formattedDate;
  }

  return null;
}
